import { gql } from '@apollo/client';

export const ADD_BENEFICIARIES_TO_INTERVENTION = gql`
  mutation addBeneficiariesToIntervention($input: AddBeneficiariesToInterventionInput!) {
    beneficiaries: addBeneficiariesToIntervention(input: $input) {
      id
    }
  }
`;
